import {
  SUCCESS_NOTIFICATION,
  FAILURE_NOTIFICATION,
} from '@/store/actions';
import { globalCommit } from '@/utils/vuex';

export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_IS_ADMIN_VIEW = 'SET_IS_ADMIN_VIEW';
export const SET_IS_NOTFOUND_VIEW = 'SET_IS_NOTFOUND_VIEW';
export const SET_IS_SITE_NOT_AVAILABLE = 'SET_IS_SITE_NOT_AVAILABLE';
export const SET_IS_IE_OR_EDGE = 'SET_IS_IE_OR_EDGE';
export const SET_HIDE_MAINTENANCE_BANNER = 'SET_HIDE_MAINTENANCE_BANNER';
export const SET_HIDE_BROWSER_BANNER = 'SET_HIDE_BROWSER_BANNER';
export const SET_SHOW_MGM_JOIN_LINK_ERROR_MODAL = 'SET_SHOW_MGM_JOIN_LINK_ERROR_MODAL';
export const GlobalModule = {
  namespaced: true,
  state: {
    pageTitle: '',
    isAdminView: null,
    isNotFoundView: false,
    isSiteNotAvailable: false,
    isIeOrEdge: false,
    hideMaintenanceBanner: true,
    hideBrowserBanner: false,
    showMGMjoinLinkErrorModal:null,
  },

  actions: {
    setPageTitle({ commit }, pageTitle) {
      commit(SET_PAGE_TITLE, pageTitle);
    },
    setIsAdminView({ commit }, isAdminView) {
      commit(SET_IS_ADMIN_VIEW, isAdminView);
    },
    setIsNotFoundView({ commit }, isNotFoundView) {
      commit(SET_IS_NOTFOUND_VIEW, isNotFoundView);
    },
    setIsSiteNotAvailable({ commit }, isSiteNotAvailable) {
      commit(SET_IS_SITE_NOT_AVAILABLE, isSiteNotAvailable);
    },
    displaySystemMessage({ commit }, message) {
      globalCommit('service', commit, SUCCESS_NOTIFICATION, message);
    },
    displaySystemErrorMessage({ commit }, message) {
      globalCommit('service', commit, FAILURE_NOTIFICATION, message);
    },
    setIsIeOrEdge({ commit } , isIeOrEdge) {
     commit(SET_IS_IE_OR_EDGE, isIeOrEdge);  
    },
    setHideMaintenanceBanner({ commit } , hideMaintenanceBanner) {
      commit(SET_HIDE_MAINTENANCE_BANNER, hideMaintenanceBanner);  
    },
    setHideBrowserBanner({ commit } , hideBrowserBanner) {
    commit(SET_HIDE_BROWSER_BANNER, hideBrowserBanner);  
    },
    setShowMGMjoinLinkErrorModal({ commit } , showMGMjoinLinkErrorModal) {
      commit(SET_SHOW_MGM_JOIN_LINK_ERROR_MODAL, showMGMjoinLinkErrorModal);  
    },
  },

  mutations: {
    [SET_PAGE_TITLE]: (state, pageTitle) => {
      state.pageTitle = pageTitle;
    },
    [SET_IS_ADMIN_VIEW]: (state, isAdminView) => {
      state.isAdminView = isAdminView;
    },
    [SET_IS_NOTFOUND_VIEW]: (state, isNotFoundView) => {
      state.isNotFoundView = isNotFoundView;
    },
    [SET_IS_SITE_NOT_AVAILABLE]: (state, isSiteNotAvailable) => {
      state.isSiteNotAvailable = isSiteNotAvailable;
    },
    [SET_IS_IE_OR_EDGE]: (state, isIeOrEdge) => {
      state.isIeOrEdge = isIeOrEdge;
    },
    [SET_HIDE_MAINTENANCE_BANNER]: (state, hideMaintenanceBanner) => {
      state.hideMaintenanceBanner = hideMaintenanceBanner;
    },
    [SET_HIDE_BROWSER_BANNER]: (state, hideBrowserBanner) => {
      state.hideBrowserBanner = hideBrowserBanner;
    },
    [SET_SHOW_MGM_JOIN_LINK_ERROR_MODAL]: (state, showMGMjoinLinkErrorModal) => {
      state.showMGMjoinLinkErrorModal = showMGMjoinLinkErrorModal;
    },
  },

  getters: {
    GET_PAGE_TITLE: state => state.pageTitle,
    GET_IS_ADMIN_VIEW: state => state.isAdminView,
    GET_IS_NOTFOUND_VIEW: state => state.isNotFoundView,
    GET_IS_SITE_NOT_AVAILABLE: state => state.isSiteNotAvailable,
    GET_IS_IE_OR_EDGE: state => state.isIeOrEdge,
    GET_HIDE_MAINTENANCE_BANNER: state => state.hideMaintenanceBanner,
    GET_HIDE_BROWSER_BANNER: state => state.hideBrowserBanner,
    GET_SHOW_MGM_JOIN_LINK_ERROR_MODAL: state => state.showMGMjoinLinkErrorModal,
  }
}
